import { gql } from 'graphql-request'

export const GET_STORY_INCOME = gql`
  query BookDashboardIncome(
    $bookType: BookType
    $categoryId: Float
    $startDate: DateTime
    $endDate: DateTime
    $limit: Int
    $orderBy: BookDetailTop100OrderBy
  ) {
    bookDashboardIncome(
      bookType: $bookType
      categoryId: $categoryId
      startDate: $startDate
      endDate: $endDate
      limit: $limit
      orderBy: $orderBy
    ) {
      income
      data {
        rank
        bookId
        bookCoverImgPath
        bookTitle
        bookType
        firstPenName
        secondPenName
        chapterCount
        countLike
        countView
        countIncome
      }
    }
  }
`
